module.exports = __webpack_public_path__ + "img/editar.50a9eeea.svg";